import { type ReactElement } from 'react'

import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

import KNMapLibre from 'components/KNMapLibre/KNMapLibre'
import type { KNDetailsPopoverMapProps } from './types'

const KNDetailsPopoverMap = ({
  markers,
  geoPoints,
  groupedGeoPoints,
}: KNDetailsPopoverMapProps): ReactElement => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Box
      sx={{
        width: isMobile ? '20rem' : '30rem',
        height: isMobile ? '20rem' : '30rem',
        marginTop: '-1px',
        backgroundColor: '#e9ecef',
        '&:first-of-type': {
          marginTop: 0,
        },
        '& > div > div': {
          backgroundColor: 'transparent !important',
        },
      }}
    >
      <KNMapLibre markers={markers} geoPoints={geoPoints} groupedGeoPoints={groupedGeoPoints} withHeading withoutLayersControl />
    </Box>
  )
}

export default KNDetailsPopoverMap
